/* Used by Storefront */

import React from "react";
import { FeaturedCategory } from "~/common/Store/models/Category";
import getCategoryImageUrl from "./getSeoCategoryImageUrl";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
interface Props {
  featuredChild: FeaturedCategory;
  categoryName: string;
  actionWord: string;
  showActionButton: boolean;
}
const GridLayoutWithNonGridSplitNoGrandchildrenView = ({
  featuredChild,
  categoryName,
  actionWord,
  showActionButton
}: Props) => {
  const {
    childCount,
    childType,
    categoryId
  } = featuredChild;
  const allowNavigatingToChildCategory = categoryId > 0;
  const singlarOrPluralChildType = (() => {
    const singularVersionNeeded = childCount === 1;
    if (singularVersionNeeded) {
      if (childType === "Categories") {
        return "Category";
      }
      if (childType === "Products") {
        return "Product";
      }
    }
    return childType;
  })();
  return <span className="border-b-0 flex flex-col items-stretch justify-between flex-auto overflow-hidden py-2-1/2 relative" data-sentry-component="GridLayoutWithNonGridSplitNoGrandchildrenView" data-sentry-source-file="GridLayoutWithNonGridSplitNoGrandchildrenView.tsx">
      <span className="block">
        <span className="flex flex-col p-4 pb-2 lg:pb-2-1/2 items-center">
          {allowNavigatingToChildCategory ? <>
              <a className="block" href={featuredChild.url} title={featuredChild.name} style={{
            flex: "0 1 70px"
          }}>
                <div className="h-24 m-0 overflow-hidden relative w-24">
                  <NoScriptLazyImage className="absolute inset-w-20" src={getCategoryImageUrl(featuredChild.image)} alt={featuredChild.name} />
                </div>
              </a>
              <a className="lg:col-span-5" href={featuredChild.url}>
                <h2 className="font-semibold text-xl leading-none mb-0 mt-2 text-center">
                  {featuredChild.name}
                </h2>
              </a>
            </> : <div className="h-0 overflow-hidden pb-72 lg:pb-full relative lg:w-full">
              <NoScriptLazyImage className="absolute inset-0 lg:w-full" src={getCategoryImageUrl(featuredChild.image)} alt={featuredChild.name} />
              <h2 className="font-semibold text-2xl leading-none mb-2-1/2">
                {featuredChild.name}
              </h2>
            </div>}
        </span>
      </span>
      {showActionButton && <div className="block float-left p-4 pt-0">
          <a href={featuredChild.url} className="btn btn-small btn-info" data-testid="subCategoryButton">
            {`${actionWord}${actionWord ? " " : ""}${featuredChild.name || categoryName}`}
          </a>
          {childCount > 0 && <p className="font-normal text-2xs leading-none mt-2 -mb-2-1/2 text-center uppercase text-gray-800">
              {`${childCount} ${singlarOrPluralChildType}`}
            </p>}
        </div>}
    </span>;
};
export default GridLayoutWithNonGridSplitNoGrandchildrenView;